import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "../../assets/scss/custom/pages/_rebate.scss";
import { OperatingUsers, Operator } from "../../assets/scss/role.constant";
import { ME } from "../../graphql/query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import SettingEditor from "../../components/CommonForBoth/SettingEditor";
import { GET_REBATES } from "../../graphql/query/GET_REBATES";
import { CALCULATE_WEEKLY_REBATES } from "../../graphql/mutation/CALCULATE_WEEKLY_REBATES";
import moment from "moment";
import _ from "lodash";
import RebateDetails from "./rebate-details";
function RebateList() {
  const { data: meData } = useQuery(ME, {
    fetchPolicy: "cache-first",
  });

  const [rebate, setRebate] = useState(null);

  const { data: rebateData } = useQuery(GET_REBATES, {
    fetchPolicy: "network-only",
  });

  const [calculateWeeklyRebates, { loading: loadingCalculateWeeklyRebates }] =
    useMutation(CALCULATE_WEEKLY_REBATES);

  return (
    <React.Fragment>
      <div className="page-content rebate-page">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Rebate" breadcrumbItem="Rebate List" />
          {meData &&
            !OperatingUsers.includes(meData.me.role) &&
            !Operator.includes(meData.me.role) && (
              <Row>
                <Col md={6} lg={6} xl={4} sm={6}>
                  <Card>
                    <CardBody>
                      <SettingEditor
                        description="Rebate Percentage"
                        settingKey="rebatePercentage"
                        settingType="General"
                        fieldType="TextField"
                        inputValue={"0.05"}
                        defaultValue={"0.05"}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )}
          <div>
            <div className="rebate-list-title">Rebate List</div>
            <Card className="p-4">
              <div className="rebate-list-container">
                {rebateData &&
                  rebateData.rebates.edges.length > 0 &&
                  rebateData.rebates.edges.map((rebate) => (
                    <div
                      key={rebate.node.id}
                      className="rebate-list-item"
                      onClick={() => {
                        setRebate(rebate.node);
                      }}
                    >
                      {rebate.node.name}
                    </div>
                  ))}
                {rebateData && rebateData.rebates.edges.length === 0 && (
                  <>
                    {!loadingCalculateWeeklyRebates ? (
                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "2px",
                        }}
                      >
                        No rebate found,
                        <div
                          className="rebate-list-item"
                          onClick={() => {
                            //get start of week is monday
                            const fromDate = moment()
                              .subtract(1, "week")
                              .startOf("isoWeek");
                            //get end of week
                            const toDate = moment()
                              .subtract(1, "week")
                              .endOf("isoWeek");
                            calculateWeeklyRebates({
                              variables: {
                                input: {
                                  fromDate: fromDate.format("YYYY-MM-DD"),
                                  toDate: toDate.format("YYYY-MM-DD"),
                                },
                              },
                            });
                          }}
                        >
                          click here to generate rebate
                        </div>
                      </p>
                    ) : (
                      <p
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "2px",
                        }}
                      >
                        Loading...
                      </p>
                    )}
                  </>
                )}
              </div>
            </Card>
          </div>
        </Container>
      </div>
      <RebateDetails
        modal={!_.isEmpty(rebate)}
        toggleModal={() => setRebate(null)}
        rebate={rebate}
      />
    </React.Fragment>
  );
}

const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  return { layoutType };
};

export default connect(mapStatetoProps)(withTranslation()(RebateList));
